// extracted by mini-css-extract-plugin
module.exports = {"container":"avg-chart_container_391F2","common":"avg-chart_common_3EvMH","title":"avg-chart_title_3xjQP","chartBox":"avg-chart_chartBox_3YJNT"};